import { isEmptyOrUndefined } from "../filter-value";

// Mirrors the Add New Loan Step 2 rules: validateContactInformation
// (contact-info-required-helper.js) + validateCreditReissueInformation
// (credit-reissue-validation-helper.js), applied to the Dashboard's state shape.

const REQUIRED_MESSAGE =
	"Please provide a value for all fields highlighted above.";

const blockKey = (block, part) =>
	block ? `${block}${part[0].toUpperCase()}${part.slice(1)}` : part;

const isZero = (v) => v === 0 || v === "0";

// street / city / state / zip, plus a non-US country when the foreign box is checked.
const collectAddressBlockErrors = (addr, prefix, block, errors) => {
	["street", "city", "state", "zip"].forEach((part) => {
		const key = blockKey(block, part);
		if (isEmptyOrUndefined(addr[key])) errors.add(`${prefix}.${key}`);
	});
	if (addr[blockKey(block, "foreignAddressIndicator")]) {
		const countryKey = blockKey(block, "country");
		const country = addr[countryKey];
		if (isEmptyOrUndefined(country) || country === "US") errors.add(`${prefix}.${countryKey}`);
	}
};

const collectApplicantErrors = (addr, prefix, errors) => {
	const a = addr || {};

	// Current
	collectAddressBlockErrors(a, prefix, "", errors);
	if (isEmptyOrUndefined(a.residencyBasisType)) errors.add(`${prefix}.residencyBasisType`);
	if (isEmptyOrUndefined(a.durationYears)) errors.add(`${prefix}.durationYears`);
	if (isZero(a.durationYears) && (isEmptyOrUndefined(a.durationMonths) || isZero(a.durationMonths))) {
		errors.add(`${prefix}.durationMonths`);
	}
	if (a.residencyBasisType === "Rent" && isEmptyOrUndefined(a.rent)) errors.add(`${prefix}.rent`);

	// Prior — only when the current address is under 2 years.
	if (!isEmptyOrUndefined(a.durationYears) && Number(a.durationYears) < 2) {
		collectAddressBlockErrors(a, prefix, "prior", errors);
	}

	// Mailing — "same as current" copies the current address, so nothing more to check.
	if (!a.mailingIsSame) collectAddressBlockErrors(a, prefix, "mailing", errors);
};

// data = { bAddr, cbAddr, hasCoBorrower, creditReissueMethod }
export const getDashboardAddressFieldErrors = (data) => {
	const errors = new Set();
	const { bAddr, cbAddr, hasCoBorrower, creditReissueMethod } = data || {};

	collectApplicantErrors(bAddr, "bAddr", errors);
	if (hasCoBorrower) collectApplicantErrors(cbAddr, "cbAddr", errors);

	if (isEmptyOrUndefined(creditReissueMethod)) errors.add("creditReissueMethod");

	return errors;
};

export const validateDashboardAddress = (data, setError) => {
	const errors = getDashboardAddressFieldErrors(data);
	if (errors.size > 0) {
		setError(REQUIRED_MESSAGE);
		return false;
	}
	return true;
};
